<template>
    <div class="registry">
        <div class="content-layout">
            <div class="column column__large">
                <div class="block" v-if="!$store.state.loadingRegistry && $store.state.carData.registry.LaaneDokumenter.length > 0">
                    <div class="title">
                        <i class="fal fa-exclamation fa-fw" />
                        Der er registreret restgæld i dette køretøj
                    </div>
                    <div class="body narrow align-top">
                        Vær opmærksom på, at der er registreret pant i dette køretøj. Det betyder, at den nuværende ejer skylder penge væk i køretøjet. Vær sikker på, at sælger får indfriet gælden inden salg.
                        <hr>
                        <line-data
                            v-for="debitor in debitors"
                            title="Debitor"
                            :value="debitor.formattedName"
                            v-bind:key="debitor.formattedName"
                        >
                            <span slot="extra" class="extra">
                                ({{ debitor.age }} år)
                            </span>
                        </line-data>
                        <line-data title="Underpanthaver" :value="$store.state.carData.registry.LaaneDokumenter[0].Underpanthaver" v-if="$store.state.carData.registry.LaaneDokumenter[0].Underpanthaver" />
                        <line-data title="Kreditor" :value="$store.state.carData.registry.LaaneDokumenter[0].Kreditorer[0].Navn" v-if="!$store.state.carData.registry.LaaneDokumenter[0].Underpanthaver && $store.state.carData.registry.LaaneDokumenter[0].Kreditorer[0]" />
                        <line-data title="Stelnummer" :value="$store.state.carData.general.StelNr" />
                        <line-data title="Type" :value="$store.state.carData.registry.LaaneDokumenter[0].DokumentType" />
                        <line-data title="Dato" :value="registryDate | moment('D. MMMM YYYY')" />
                        <line-data title="Hovedstol" :value="$store.state.carData.registry.LaaneDokumenter[0].HovedStol | currency" suffix="kr." />
                        <line-data title="Rente" :value="$store.state.carData.registry.LaaneDokumenter[0].InterestRate" suffix="%" />
                        <line-data title="Særlige vilkår" :value="$store.state.carData.registry.LaaneDokumenter[0].SaerligeLaanevilkaar" />
                        <line-data title="Løbenummer" :value="$store.state.carData.registry.LaaneDokumenter[0].LoebeNummer" />
                        <line-data
                            title="Bemærkninger"
                            v-for="(warning, index) in $store.state.carData.registry.LaaneDokumenter[0].TillaegsTekster"
                            :value="warning"
                            v-bind:key="warning"
                            v-if="index === 0"
                        />
                        <line-data
                            title=""
                            v-for="(warning, index) in $store.state.carData.registry.LaaneDokumenter[0].TillaegsTekster"
                            :value="warning"
                            v-bind:key="warning"
                            v-if="index !== 0"
                        />
                        <hr>
                        <div class="meta" style="opacity:.5;">
                            <div>
                                Oplysningerne opdateres en gang i døgnet.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="block" v-else>
                    <div class="title">
                        <i class="fal fa-check fa-fw" />
                        Ingen restgæld registreret i dette køretøj
                    </div>
                    <div class="body">
                        Ifølge de offentlige oplysninger, som vi indhenter, er der ingen restgæld (pant) i dette køretøj.
                        <br><br>
                        Vi opdaterer vores oplysninger en gang i døgnet
                        <br><br>
                        Tjek venligst <a href="https://www.tinglysning.dk/t/#/top/forespoerg/bilbogen" target="_blank" rel="noopener">www.tingstyrelsen.dk</a> for de nyeste oplysninger.
                        <br>
                        Du skal bruge køretøjets stelnummer, som er <b>{{ $store.state.carData.general.StelNr }}</b>.
                    </div>
                </div>
            </div>
            <div class="column column__small">
                <div class="block">
                    <div class="title">
                        BilBogen
                    </div>
                    <div class="body">
                        BilBogen er et offentligt register, hvor kreditorer kan registrere pant og udlæg over motorkøretøjer (bil, motorcykel m.fl.).
                        <br><br>
                        Alle oplysninger i BilBogen er offentlige og kan findes på <a href="https://tinglysning.dk" target="_blank" rel="noopener">www.tinglysning.dk</a>.
                    </div>
                </div>
                <div class="block">
                    <div class="title">
                        Restgæld / pant
                    </div>
                    <div class="body">
                        Kreditorer, som låner penge til køb af motorkøretøjer, kan få stillet sikkerhed i motorkøretøjet (pant) for at sikre, at debitor betaler gælden. Hvis gælden misligholdes, kan kreditor sælge bilen for at inddrive det skyldige beløb.
                        <br><br>
                        Der er intet farligt i at købe en brugt bil med restgæld / pant. Du skal blot sikre dig, at sælger indfrier denne gæld ved købet.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    computed: {
        debitors () {
            if (this.$store.state.carData.registry.LaaneDokumenter.length > 0) {
                this.$store.state.carData.registry.LaaneDokumenter[0].Debitorer.forEach((debitor) => {
                    let firstname = debitor.Navn.split(' ')[0]
                    let lastname = debitor.Navn.split(' ')[1].substring(0, 1)
                    let birthday = moment(debitor.FoedselsDato.substring(0, 6), 'DDMMYYYY').format('X')
                    let today = moment(new Date()).format('X')
                    let years = ((today - birthday) / 86400) / 365
                    debitor.formattedName = firstname + ' ' + lastname + '.'
                    if (Math.floor(years) < 0) {
                        debitor.age = 100 + Math.floor(years)
                    } else {
                        debitor.age = Math.floor(years)
                    }
                })
                return this.$store.state.carData.registry.LaaneDokumenter[0].Debitorer
            }
        },
        registryDate () {
            if (this.$store.state.carData.registry.LaaneDokumenter.length > 0) {
                return moment(this.$store.state.carData.registry.LaaneDokumenter[0].Dato, 'DD-MM-YYYY').format('YYYY-MM-DD')
            }
        }
    }
}
</script>




// WEBPACK FOOTER //
// registry.vue?3fe790be